import React from 'react';
import DiamondFilled from '@uber/base-icons/diamond-filled';
import { useStyletron } from 'baseui';
import type { StyleObject } from 'styletron-react';
import { DIAMOND_SIZE } from '../../../constants/frame-timeline-v4';
type KeyframeDiamondPropsT = {
  /** The annotation's own color, used as-is; the span around it is the part that's darkened. */
  color?: string;
};
const getWrapperStyle = (): StyleObject => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  pointerEvents: 'none'
});
export const KeyframeDiamond = ({
  color
}: KeyframeDiamondPropsT) => {
  const [css, theme] = useStyletron();
  return <div data-testid="keyframe-diamond" className={css(getWrapperStyle())}>
      <DiamondFilled color={color ?? theme.colors.borderSelected} width={DIAMOND_SIZE} height={DIAMOND_SIZE} />
    </div>;
};